export const urlRegex =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9-#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export const phoneRegex =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const engRegex =
  /^[a-zA-Z0-9 \r\n[\]!@#$&()`.+/\\/~:;{},|\-/<>"-*?%^_=]*$/;

export const arRegex =
  /^[\u0621-\u064A0-9 \r\n[\]!@#$&()`.+/\\/~:;{},|\-/<>"-*؟?%^_=]*$/;
